export default __webpack_public_path__ + "static/media/amazonashero.c2d0cf99.jpg";